import { gsap } from 'gsap';

document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('#whatsnew');

  if (!el) return;

  const init = () => {
    const close = el.querySelector('.js-close');
    const trigger = el.querySelector('.js-trigger');
    const popup = el.querySelector('.js-popup');
    const readMore = el.querySelector('.js-readmore');

    const STORAGE_KEY = 'whatsnew-popup-closed';

    const tl = gsap.timeline({
      clearProps: 'all',
    });

    const toggle = (height, section, opacity) => {
      if (!section) return;

      tl.to(section, {
        height,
        opacity,
        duration: 0.5,
        ease: 'elastic.out(1, .8)',
      });
    };

    const hidePopup = () => {
      toggle(0, popup, 0);

      el.classList.add('is-pulse');

      localStorage.setItem(STORAGE_KEY, 'true');
    };

    const showPopup = () => {
      el.classList.remove('is-pulse');

      toggle('auto', popup, 1);
    };

    const handleReadMore = () => {
      el.classList.add('in-full-mode');

      if (popup) {
        toggle('auto', popup.querySelector('article'), 1);
      }
    };

    if (close) {
      close.addEventListener('click', hidePopup);
    }

    if (trigger) {
      trigger.addEventListener('click', showPopup);
    }

    if (readMore) {
      readMore.addEventListener('click', handleReadMore);
    }

    const openOnStart = el.classList.contains('open-on-start');
    const wasClosed = localStorage.getItem(STORAGE_KEY) === 'true';

    if (openOnStart && !wasClosed) {
      showPopup();
    }
  };

  init();
});